import { MDSDateRangePicker } from '@marqvision/mds-v2';
import { useQueryParams } from '@marqvision/shared';
import { useLogger } from '~/hooks';
import { FilterQueryParams } from '~/pages/DomainNames/@types';

type DateRangeFilterProps = {
  startDateKey: keyof FilterQueryParams;
  endDateKey: keyof FilterQueryParams;
  label: string;
  logType: string;
};

export const DomainNamesDateRangeFilter = ({ startDateKey, endDateKey, label, logType }: DateRangeFilterProps) => {
  const { amplitudeLogging } = useLogger();
  const filterParams = useQueryParams<FilterQueryParams>();

  const startDate = filterParams.params[startDateKey] as string | undefined;
  const endDate = filterParams.params[endDateKey] as string | undefined;

  const dateRange =
    startDate || endDate
      ? {
          startDate: startDate || undefined,
          endDate: endDate || undefined,
        }
      : undefined;

  const handleChange = (date?: { startDate: string; endDate: string }) => {
    if (date) {
      filterParams.setParams({ [startDateKey]: date.startDate, [endDateKey]: date.endDate });
    } else {
      filterParams.removeParams([startDateKey, endDateKey]);
    }

    if (startDate || endDate) {
      amplitudeLogging('applied filter', {
        Type: logType,
        Channel: 'domain names',
        Page: 'domain list',
      });
    }
  };

  const chipVariant = dateRange?.startDate || dateRange?.endDate ? 'fill' : 'tint';

  return (
    <MDSDateRangePicker
      value={
        dateRange
          ? {
              startDate: dateRange?.startDate || '',
              endDate: dateRange?.endDate || '',
            }
          : undefined
      }
      onChange={handleChange}
      anchor={{
        variant: 'filter',
        mdsButtonProps: {
          variant: chipVariant,
          children: label,
        },
        format: 'MMM DD, YYYY',
      }}
    />
  );
};
